import css from 'styled-jsx/css';

const styles = css.global`#open-finance-o-que-e {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #222;
  margin-top: -3px;
}

#open-finance-o-que-e picture{
  display: block;
  width: 100%;
  height: 248px;
}

#open-finance-o-que-e .img-o-que-e-open-finance {
  width: 100%;
  height: 248px;
  object-fit: cover;
  object-position: top;
}

#open-finance-o-que-e .o-que-e-conteudo {
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#open-finance-o-que-e .o-que-e-conteudo img {
  width: 40px;
}

#open-finance-o-que-e .o-que-e-titulo {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

#open-finance-o-que-e .o-que-e-texto {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

@media (min-width: 992px) {
  #open-finance-o-que-e {
    padding: 80px 0 99px;
  }

  #open-finance-o-que-e .ctn-home-24 {
    display: flex;
    align-items: center;
    gap: 80px;
  }

  #open-finance-o-que-e picture,
  #open-finance-o-que-e .img-o-que-e-open-finance {
    width: 550px;
    height: 706px;
    margin-left: -36px;
    border-radius: 4px;
  }

  #open-finance-o-que-e .o-que-e-conteudo {
    width: 595px;
    height: 569px;
    padding: 0 8px;
    gap: 24px;
  }

  #open-finance-o-que-e .o-que-e-titulo {
    font-size: 72px;
  }

}`;

export default styles;